var map = {
	"./background.jpg": "1100",
	"./background_1.jpg": "a1d8",
	"./background_10.jpg": "c52a",
	"./background_11.jpg": "6224",
	"./background_12.jpg": "6d85",
	"./background_13.jpg": "604e",
	"./background_14.jpg": "a77b",
	"./background_15.jpg": "9a1c",
	"./background_16.jpg": "d995",
	"./background_17.jpg": "bd7a",
	"./background_18.jpg": "07cd",
	"./background_19.jpg": "480f",
	"./background_2.jpg": "b9bd",
	"./background_3.jpg": "93cf",
	"./background_4.jpg": "b619",
	"./background_5.jpg": "08c3",
	"./background_6.jpg": "baea",
	"./background_7.jpg": "7d3c",
	"./background_8.jpg": "504a",
	"./background_9.jpg": "25cb",
	"./brand.svg": "2b3a",
	"./colors.scss": "62d7",
	"./custom.scss": "de82",
	"./feature-1.png": "b460",
	"./fonts.scss": "7929",
	"./fonts/texgyrepagella-bold.otf": "791d",
	"./fonts/texgyrepagella-bolditalic.otf": "49b7",
	"./fonts/texgyrepagella-italic.otf": "ec82",
	"./fonts/texgyrepagella-regular.otf": "75fe",
	"./logo-footer-1.svg": "d097",
	"./logo-footer-2.png": "f0b2",
	"./logo-footer-3.jpg": "1efb",
	"./logo-footer.jpg": "364b",
	"./logo.png": "cf05",
	"./variables.scss": "7133"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";